
import React from "react";
import { FlexGrid, Typography, useThemeProvider, Card } from '@albo-ui/core'


export type CountItemProps = {
    title: string;
    subtitle?: string;
    count: number;
    width?: string;
    height?: string;

}
export const CountItem = ({ title, subtitle, count, width, height }: CountItemProps) => {
    const { theme } = useThemeProvider();
    const formatNumber = count.toLocaleString('en-US', { minimumFractionDigits: 0 })
    //Por defecto 5 columnas
    return <FlexGrid container direction="column" style={{ flexBasis: width || `calc((100% - ${theme.spaces[3]}px * 5) / 5)` }}>
        <Card padding={2} flexDirection="column" fullWidth height={height || "110px"} alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee }}>
            <FlexGrid item direction="column">
                <FlexGrid item direction="column">
                    <Typography variant="paragraph" color="lightNeutral">
                        {title}
                    </Typography>
                </FlexGrid>
                <FlexGrid item direction="column">
                    {subtitle &&
                        <Typography variant="small" bold color="lightNeutral">
                            {subtitle}
                        </Typography>
                    }
                </FlexGrid>
            </FlexGrid>

            <FlexGrid item style={{ marginTop: theme.spacesPx[1] }}>
                <Typography variant="h1">
                    {formatNumber}
                </Typography>
            </FlexGrid>
        </Card>
    </FlexGrid>



}
